import { useBlockProps } from '@wordpress/block-editor';
import { Notice } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
/**
 * Edit component for the Thank You block
 * Uses plugin settings to determine which Thank You page to display
 */
export const Edit = () => {
	// Get the selected page ID from settings
	const selectedPageId =
		window.redfoxThankYouSettings?.defaults?.selectedThankYouPageCpt || 0;

	const blockProps = useBlockProps( {
		className: 'redfox-thank-you-block',
	} );

	return (
		<div { ...blockProps }>
			<div className="redfox-thank-you-content">
				<div className="editor-preview-notice">
					{ selectedPageId && (
						<Notice status="info" isDismissible={ false }>
							{ __(
								'The content from the Thank You page selected in plugin settings will be displayed here in the Frontend.',
								'redfox-thank-you',
							) }
						</Notice>
					) }
					{ ! selectedPageId && (
						<Notice status="warning" isDismissible={ false }>
							<p>
								{ __(
									'No Thank You page selected in plugin settings.',
									'redfox-thank-you',
								) }{ ' ' }
								<a href="/wp-admin/admin.php?page=redfox-thank-you-settings">
									{ __(
										'Go to Settings',
										'redfox-thank-you',
									) }
								</a>
							</p>
						</Notice>
					) }
				</div>
			</div>
		</div>
	);
};
